/** Shared staleTime for person queries so batch warm-up and single-get stay in sync. */
export const PERSON_QUERY_STALE_TIME_MS = 30 * 60 * 1000;
